import { TechnicalSkillsList } from "./components/technicalSkillsList";
import { FormComponent } from "./components/formModelOne";
import React, { Component } from "react";
import { Button, Form, Modal } from "antd";
import { connect } from "react-redux";
import * as loginActions from "../../actions";
import "./step10.css";

class StepTen extends Component {
  constructor(props) {
    super(props);
    // 
    // 
    this.state = {
      visible: false,
      loading: false,
      showOther: false,
      preUrl: "https://"
    };
  }

  showModal = () => {
    this.props.modelFromStep(true, false, 11);
  };

  handleCancel = () => {
    this.props.modelFromStep(false, false, 11);
  };

  deleteProjectHandler =  (itemToDelete) => {
    this.props.deleteItem(
      itemToDelete
    );
  };

  onChange = value => {
    if (value === "HackerEarth") {
      this.setState({ preUrl: "https://www.hackerearth.com/@" });
    }
    if (value === "HackerRank") {
      this.setState({ preUrl: "https://www.hackerrank.com/" });
    }
    if (value === "GeeksForGeeks") {
      this.setState({ preUrl: "https://auth.geeksforgeeks.org/user/" });
    }
    if (value === "CodeChef") {
      this.setState({ preUrl: "https://www.codechef.com/users/" });
    }
    if (value === "InterviewBit") {
      this.setState({ preUrl: "https://www.interviewbit.com/profile/" });
    }
    if (value === "CodeForces") {
      this.setState({ preUrl: "http://codeforces.com/profile/" });
    }
    if (value === "Spoj") {
      this.setState({ preUrl: "https://www.spoj.com/users/" });
    }
    if (value === "TopCoder") {
      this.setState({ preUrl: "https://www.topcoder.com/members/" });
    }
    if (value === "Github") {
      this.setState({ preUrl: "https://www.github.com/" });
    }
    if (value === "StackOverFlow") {
      this.setState({ preUrl: "https://stackoverflow.com/users/" });
    }
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      }
    };

    let { programmingWebsitesProfiles } = this.props.profile;
    const { preUrl } = this.state;
    if (typeof programmingWebsitesProfiles == "undefined") {
      programmingWebsitesProfiles = [];
    }

    const { form } = this.props;
    const { getFieldDecorator, validateFields } = form;
    const onValidateForm = e => {
      e.preventDefault();
      validateFields((err, values) => {
        if (!err) {
          // 
          // 
          this.props.stepTenSubmit(
            values,
            "programmingWebsitesProfiles",
            this.props.itemIndex
          );
        }
      });
    };

    // 

    return (
      <>
        <Modal
          visible={this.props.visible.visible}
          title={`Add new Profile`}
          onCancel={this.handleCancel}
          destroyOnClose
          footer={[
            <Button
              key="submit"
              type="primary"
              loading={this.props.visible.loading}
              onClick={onValidateForm}
            >
              {`Add Profile`}
            </Button>
          ]}
        >
          <FormComponent
            technicalSkills={programmingWebsitesProfiles}
            formItemLayout={formItemLayout}
            getFieldDecorator={getFieldDecorator}
            preUrl={preUrl}
            onChange={this.onChange}
          />
        </Modal>
        <h2 className="steponeHeading">Add programming websites profile</h2>
        <p className="steponeDisc">
          Add your profile from different coding platforms (Eg: CodeChef,
          HackerEarth,HackerRank..etc)
        </p>

        <TechnicalSkillsList
          technicalSkills={programmingWebsitesProfiles}
          showModal={this.showModal}
          deleteItem={this.deleteProjectHandler}
        />

        <p style={{ marginTop: 11, marginBottom: 21 }}>
          *{" "}
          <b style={{ fontWeight: 500 }}>
            if you don't have or you don't want to add any external profile
          </b>
          , you may skip this step and press done.{" "}
        </p>

        <Button
          type="primary"
          onClick={() => {
            this.props.goToNextStep(11);
          }}
        >
          Done
        </Button>
      </>
    );
  }
}

const mapStateToProps = state => {
  // 
  // 
  return {
    auth: state.firebase.auth,
    step: state.auth.step,
    visible: state.auth,
    profile: state.firebase.profile,
    itemIndex: state.auth.itemIndex
  };
};

const mapDispachToProps = (dispatch, props) => ({
  stepTenSubmit: (formValue, categary, itemIndex = null) => {
    dispatch(
      loginActions.stepCpVerify(
        formValue,
        props.history,
        categary,
        11,
        itemIndex
      )
    );
  },
  modelFromStep: (visible, loading, step, itemIndex = null) => {
    dispatch(loginActions.modelFromStep(visible, loading, step, itemIndex));
  },
  goToNextStep: step => {
    dispatch(loginActions.goToStep(step, props.history));
  },
  deleteItem: (itemToDelete) => {
    dispatch(loginActions.deleteItem("programmingWebsitesProfiles",itemToDelete));
  }
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(Form.create()(StepTen));
